import React, { useState, useContext } from "react";
import LogoImg from "../assets/images/kuppi-logo.png";
import { LinkData } from "../assets/data/dummydata";
import { NavLink, useNavigate } from "react-router-dom";
import { CgLogIn, CgLogOut } from "react-icons/cg";
import { HiOutlineMenuAlt1 } from "react-icons/hi";
import LoginSignupPopup from "./LoginSignupPopup";
import { AuthContext } from "../../context/AuthContext";
import PocketBase from "pocketbase";
import MidImg from "../assets/images/Upper-logo.png";

const pb = new PocketBase(process.env.REACT_APP_POCKETBASE_URL);

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { auth, setAuth } = useContext(AuthContext);

  const navigate = useNavigate();

  const handleMenuToggle = () => {
    setOpen(!open);
  };

  const redirectToLogin = () => {
    sessionStorage.setItem("redirect", window.location.pathname);
    navigate("/login");
  };

  const handleLogout = async () => {
    setLoading(true);
    try {
      pb.authStore.clear();
      localStorage.removeItem("token");
      setAuth({ isAuthenticated: false, token: null });
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      setLoading(false);
    }
  };


  const lastFourLinks = LinkData.slice(-4);


  const abbreviateTitle = (title) => {
    switch (title) {
      case "Bodim":
        return "Bodim";
      case "O/L Api":
        return "O/L";
      case "A/L Api":
        return "A/L";
      case "Job Market":
        return "Jobs";
      default:
        return title;
    }
  };

  return (
    <>
      <header className="bg-white py-4 text-black sticky z-50 shadow-md top-0 left-0 w-full overflow-hidden">
        <div className="flex justify-between items-center mr-2 ml-2 lg:mr-10 lg:ml-10">
          <div className="logo flex items-center gap-6 ml-3">
            <img src={LogoImg} alt="logo" className="h-6 sm:h-3 lg:h-6" />
          </div>

          <div className="logo items-center gap-6 hidden lg:flex">
            <img src={MidImg} alt="logo" className="h-8 sm:h-7 lg:h-10" />
          </div>

          <nav className="flex lg:hidden items-center justify-center gap-2 w-full">
            {lastFourLinks.map((link) => (
              <NavLink
                key={link.id}
                className={({ isActive }) =>
                  isActive
                    ? "text-primary font-bold text-xs no-underline bg-gray-200 rounded-full px-2 py-1"
                    : "text-gray-700 font-bold text-xs no-underline hover:text-primary transition"
                }
                to={link.url}
              >
                {abbreviateTitle(link.title)}
              </NavLink>
            ))}
          </nav>

          <nav className={`${open ? "block" : "hidden"} lg:flex lg:items-center`}>
            <ul className="flex flex-col lg:flex-row items-center gap-6">
              {LinkData.map((link) => (
                <li key={link.id} onClick={() => setOpen(false)}>
                  <NavLink
                    className={({ isActive }) =>
                      isActive
                        ? "text-primary font-bold text-sm no-underline bg-gray-200 rounded-full px-3 py-1"
                        : "text-gray-700 font-bold text-sm no-underline hover:text-primary transition"
                    }
                    to={link.url}
                  >
                    {link.title}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>

          <div className="account flex items-center gap-2 lg:gap-5">
            {!auth.isAuthenticated ? (
              <button
                className="px-1 py-1 lg:px-2 lg:py-1 bg-primary text-white rounded-md hover:bg-opacity-80 transition flex flex-row items-center gap-1 lg:gap-2 text-xs lg:text-sm"
                onClick={redirectToLogin}
              >
                <span className="whitespace-nowrap inline-flex items-center gap-1 lg:gap-2">
                  Login <CgLogIn className="text-xl lg:text-2xl" />
                </span>
              </button>
            ) : (
              <button
                className="px-1 py-1 lg:px-2 lg:py-1 bg-primary text-white rounded-md hover:bg-opacity-80 transition flex flex-row items-center gap-1 lg:gap-2 text-xs lg:text-sm"
                onClick={handleLogout}
                disabled={loading}
              >
                <span className="whitespace-nowrap inline-flex items-center gap-1 lg:gap-2">
                  {loading ? "Logging out..." : "Logout"} <CgLogOut className="text-xl lg:text-2xl" />
                </span>
              </button>
            )}
            <button className="open-menu lg:hidden mr-3" onClick={handleMenuToggle}>
              <HiOutlineMenuAlt1 size={25} />
            </button>
          </div>
        </div>
        <LoginSignupPopup open={popupOpen} onClose={() => setPopupOpen(false)} />
      </header>
    </>
  );
};